import { render } from "./LayoutNewDesign.vue?vue&type=template&id=a7aa1fa2&scoped=true"
import script from "./LayoutNewDesign.vue?vue&type=script&lang=js"
export * from "./LayoutNewDesign.vue?vue&type=script&lang=js"

import "./LayoutNewDesign.vue?vue&type=style&index=0&id=a7aa1fa2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7aa1fa2"]])

export default __exports__